import React, { useEffect } from "react";
import { BrowserRouter, useHistory } from "react-router-dom";
import { Switch } from "react-router-dom";
import "./App.css";
import Order from "./Components/Order";
import Home from "./Components/Home";
import Inventry from "./Components/Inventry";
import Profile from "./Components/Profile";
import Verification from "./Components/auth/Verification";
import Login from "./Components/auth/Login";
import Welcome from "./Components/auth/Welcome";
import Notfound from "./Components/Notfound";
import Add from "./Components/addProduct/Add";
import Negotiation from "./Components/Negotiation";
import Categories from "./Components/addProduct/ChooseProduct/Categories";
import Category from "./Components/addProduct/ChooseProduct/CategoryNewDesign";
//import Category from "./Components/addProduct/ChooseProduct/Category";
import Image from "./Components/addProduct/EnterProduct/Image";
import Name from "./Components/addProduct/EnterProduct/Name";
import AddNewProductCard from "./Components/common/AddNewProductCard";
import Notification from "./Components/Notification";
import Review from "./Components/Review";
import Question_answer from "./Components/Question_answer";
import InternetError from "./Components/InternetError";
import Termsconditions from "./Components/Terms&Conditions/Termsconditions";
import { useAlert } from "react-alert";
import Forms from "./Components/addProduct/EnterProduct/Forms";
import { ProtectedRoutes } from "./Routes/ProtectedRoutes";
import PublicRoutes from "./Routes/PublicRoutes";
import HomeNew from "./Components/HomeNew";
import ProductDetail from "./Components/common/ProductDetail";
import Register1 from "./Components/auth/Register1";
import Register2 from "./Components/auth/Register2";
import Register3 from "./Components/auth/Register3";
import Register4 from "./Components/auth/Register4";
import NewVendProSuccess from "./Components/addProduct/NewVendProSuccess";
import Payment from "./Components/Payment";
import SearchResultPage from "./Components/addProduct/ChooseProduct/SearchResultPage";
import BulkUploadProd from "./Components/addProduct/BulkUploadProd";
import Enquiry from "./Components/Enquiry";
import ProductDetConf from "./Components/common/ProductDetConf";
import VideosTuts from "./Components/Tutorials/VideosTuts";
import { Provider, useDispatch } from "react-redux";
import store from "./Store";

import NewRegistration from "./Components/auth/NewRegistration";
import SessionExpired from "./Components/SessionExpired";
import NewLeads from "./Components/Leads";

import Brands from "./Components/Brands"
import MyBrands from "./Components/MyBrands"
import CustomerSupport from "./Components/CustomerSupport";
import Products from "./Components/addProduct/products";
import QuestionAnswers from "./Components/questionAnswer/QuestionAnswers";
import CustomerLeads from "./Components/CustomerLeads/CustomerLeads";
import WalletTrasaction from "./Components/WalletTransaction/Transactions";
import Leads from "./Components/CustomerLeads/Leads";
import LockedLeads from "./Components/CustomerLeads/LockedLeads";
import Opportunities from "./Components/Opportunities";
import { messaging } from "./firebase";
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import api from "./seller-apis/api";
import { meOnly } from "./seller-apis/apidataField";
import CustomerReviews from "./Components/CustomerReviews";
import SellerSupport from "./Components/SellerSupport";
import Notices from "./Components/BrandNotice/Notice";
import BrandStep1 from "./Components/Brands/brandStep1";
import BrandStep2 from "./Components/Brands/brandStep2";
import BrandTransactions from "./Components/MyBrands/BrandTransactions";
import RegisterSuccess from "./Components/auth/RegisterSuccess";
import ProductFormSystem from "./Components/AddProductForm/index";

import Frozen from "./Components/Frozen";
import FrozenRoute from "./Routes/FrozenRoute";
import SellerFAQ from "./Components/SellerFAQ/SellerFAQ";
// Inner component that can use useHistory hook

import { Actions } from "./Actions/Actions";
import { requestFCMToken, setupTokenValidation, setupMessageListener } from "./utilities/fcmTokenManager";
import { useNotification, NotificationProvider } from "./Components/common/OrderLost/NotificationContext";
import NotificationContainer from "./Components/common/OrderLost/NotificationContainer";
import RegistrationStep2 from "./Components/Registration/Step2";
// Component to handle service worker navigation messages
function NavigationHandler() {
  const history = useHistory();

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      const handleMessage = (event) => {
        if (event.data && event.data.type === 'NAVIGATE') {
          history.push(event.data.path);
        }
      };

      navigator.serviceWorker.addEventListener('message', handleMessage);
      return () => {
        navigator.serviceWorker.removeEventListener('message', handleMessage);
      };
    }
  }, [history]);

  return null;
}

function AppContent() {
  const alert = useAlert();
  const dispatch = useDispatch();
  const {addOrderLostNotification} = useNotification();

  // Handle online/offline events
  window.addEventListener("online", () => {
    alert.show("online");
    window.location.reload();
  });

  window.addEventListener("offline", () => alert.show("offline"));

  useEffect(() => {
    let handleServiceWorkerMessage;

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then(() => {
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });

      handleServiceWorkerMessage = (event) => {
        if (event.data && event.data.type === 'FCM_TOKEN_REFRESH') {
          requestFCMToken(true).then((token) => {
            if (token) {
              console.log('Token refreshed and updated successfully');
            }
          });
        }
      };

      navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);
    }

    // Request FCM token on mount
    requestFCMToken().then((token) => {
      if (token) {
      }
    });
    
   // Set up periodic token validation (runs every 24 hours)
  const stopValidation = setupTokenValidation();

  window.addEventListener("offline", () => alert.show("offline"));


    // Cleanup on unmount
    return () => {
      stopValidation();
      if ('serviceWorker' in navigator && handleServiceWorkerMessage) {
        navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage);
      }
    };
  }, [])
  return (
    <BrowserRouter>
    <Provider store={store}>
      <NavigationHandler />
      <Switch>
        <ProtectedRoutes exact path="/home" component={Home} />
        <FrozenRoute exact path="/frozen" component={Frozen} />
        <ProtectedRoutes exact path="/homenew" component={HomeNew} />
        <ProtectedRoutes path="/my-order" component={Order} />
        <ProtectedRoutes path="/my-enquiry" component={Enquiry} />
        <ProtectedRoutes path="/my-inventory" component={Inventry} />
        <ProtectedRoutes
          exact
          path="/my-inventory?tab=newrequest"
          component={Inventry}
        />
        <ProtectedRoutes path="/questions" component={QuestionAnswers} />
        <ProtectedRoutes path="/customer-leads" component={CustomerLeads} />
        <ProtectedRoutes path="/leads" component={Leads} />
        <PublicRoutes path="/register-success/:id" component={RegisterSuccess} />
        <ProtectedRoutes path="/locked-leads" component={LockedLeads} />
        <ProtectedRoutes path="/wallet-transaction" component={WalletTrasaction} />
        <ProtectedRoutes exact path="/bulk-upload" component={BulkUploadProd} />
        <ProtectedRoutes exact path="/apply-brand" component={Brands} />
        <ProtectedRoutes exact path="/apply-brand/1/:id" component={BrandStep1} />
        <ProtectedRoutes exact path="/apply-brand/1" component={BrandStep1} />
        <ProtectedRoutes exact path="/apply-brand/2/:id" component={BrandStep2} />
        <ProtectedRoutes exact path="/my-brands/" component={MyBrands} />
        <ProtectedRoutes exact path="/brand/transaction" component={BrandTransactions} />
        <ProtectedRoutes exact path="/profile" component={Profile} />
        <PublicRoutes
          exact
          path="/verification/:mobile"
          component={Verification}
        />
        <PublicRoutes exact path="/" component={NewLeads} />
        <PublicRoutes exact path="/register" component={NewLeads} />
        <PublicRoutes exact path="/newsignup" component={NewRegistration} />
        <PublicRoutes exact path="/login" component={Login} />
        <PublicRoutes exact path="/login/:no" component={Login} />
        <PublicRoutes exact path="/register/2" component={Register2} />
        <PublicRoutes exact path="/register/3" component={Register3} />
        <PublicRoutes exact path="/register/4" component={Register4} />
        <PublicRoutes exact path="/register/step2" component={RegistrationStep2} />
        <PublicRoutes
          exact
          path="/regprosuccess"
          component={NewVendProSuccess}
        />
        <ProtectedRoutes
          exact
          path="/chooseProduct/categories"
          component={Categories}
        />
        <ProtectedRoutes
          exact
          path="/chooseProduct/category"
          component={Category}
        />
        <ProtectedRoutes
          exact
          path="/chooseProduct/category?=newVendor"
          component={Category}
        />
        <ProtectedRoutes
          exact
          path="/enterProduct/addProduct"
          component={Name}
        />
        <ProtectedRoutes
          exact
          path="/enterProduct/enter-Details/:id/:page/:from"
          component={Image}
        />
        <ProtectedRoutes
          exact
          path="/enterProduct/enter-Details/"
          component={Image}
        />
        <ProtectedRoutes exact path="/add-Product" component={Category} />
        <ProtectedRoutes
          exact
          path="/productcard"
          component={AddNewProductCard}
        />
        <ProtectedRoutes
          exact
          path="/notification"
          component={Notification}
        />
        <ProtectedRoutes exact path="/q&a" component={Question_answer} />
        <ProtectedRoutes exact path="/review" component={Review} />
        <ProtectedRoutes
          exact
          path="/productDetail/:pId/:from"
          component={ProductDetail}
        />
        <ProtectedRoutes
          exact
          path="/productDetConf/:pId"
          component={ProductDetConf}
        />
        <ProtectedRoutes exact path="/negotiation" component={Negotiation} />
        <ProtectedRoutes path="/payment" component={Payment} />
        <ProtectedRoutes path="/opportunities" component={Opportunities} />
        <ProtectedRoutes path="/support" component={CustomerSupport} />
        <ProtectedRoutes path="/seller-support" component={SellerSupport} />
        <ProtectedRoutes path="/customerReviews" component={CustomerReviews} />
        <ProtectedRoutes exact path="/t&c" component={Termsconditions} />
        <ProtectedRoutes exact path="/form/:id?/:type?" component={Forms} />
        <ProtectedRoutes exact path="/products" component={Products} />
        <ProtectedRoutes exact path="/form?=newVendor" component={Forms} />
        <ProtectedRoutes
          exact
          path="/searchProductsList/:srchVal"
          component={SearchResultPage}
        />
        <ProtectedRoutes
          exact
          path="/tutorials/videos"
          component={VideosTuts}
        />
        {/* sl - 741 */}
        <ProtectedRoutes
          exact
          path="/brand-notice"
          component={Notices}
        />
        <ProtectedRoutes
        exact
        path="/faq-list"
        component={SellerFAQ}
      />
        <PublicRoutes exact path="/error" component={InternetError} />
        <PublicRoutes
          exact
          path="/session_expired"
          component={SessionExpired}
        />
        {/* sl - 741 */}
        <ProtectedRoutes
          exact
          path="/add-product1"
          component={ProductFormSystem}
        />
         <ProtectedRoutes
          exact
          path="/edit-product1/:id"
          component={ProductFormSystem}
        />
        <PublicRoutes exact path="" component={Notfound} />
      </Switch>
      </Provider>
    </BrowserRouter>
  );
}

function App() {
  return (
    <NotificationProvider>
      <AppContent />
      <NotificationContainer />
    </NotificationProvider>
  );
}

export default App;
